var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"id":"header","src":_vm.getConfig('VUE_APP_CUSTOMER_HEADER_SRC')}})}
var staticRenderFns = []

export { render, staticRenderFns }